import axios from "axios"
import efpaConfig from "../utils/efpaConfig"

export const fetcherServer = axios.create({
  baseURL: efpaConfig.PROXY_URL,
})